import NannyShare from '@/icons/requirements/NannyShare.vue';
import LearningPod from '@/icons/requirements/LearningPod.vue';
import Tutoring from '@/icons/requirements/Tutoring.vue';
import DrivingTheKids from '@/icons/requirements/DrivingTheKids.vue';
import HelpWithHomework from '@/icons/requirements/HelpWithHomework.vue';
import PreparingSnacksAndMeals from '@/icons/requirements/PreparingSnacksAndMeals.vue';
import SickCare from '@/icons/requirements/SickCare.vue';
import Bedtime from '@/icons/requirements/Bedtime.vue';
import ToiletTraining from '@/icons/requirements/ToiletTraining.vue';
import LightHousekeeping from '@/icons/requirements/LightHousekeeping.vue';
import LightLaundry from '@/icons/requirements/LightLaundry.vue';
import RunningErrands from '@/icons/requirements/RunningErrands.vue';
import { Responsibilities } from '@/store/modules/job/types';

export interface ResponsibilityOption {
  value: Responsibilities;
  textLabel: string;
  icon: any;
}

export const responsibilityOptions: ResponsibilityOption[] = [
  { value: Responsibilities.NANNY_SHARE, icon: NannyShare, textLabel: 'Nanny share' },
  { value: Responsibilities.LEARNING_POD, icon: LearningPod, textLabel: 'Learning pod' },
  { value: Responsibilities.TUTORING, icon: Tutoring, textLabel: 'Tutoring' },
  { value: Responsibilities.DRIVING_THE_KIDS, icon: DrivingTheKids, textLabel: 'Driving the kids' },
  { value: Responsibilities.HOMEWORK_HELP, icon: HelpWithHomework, textLabel: 'Help with homework' },
  { value: Responsibilities.PREPARE_SNACKS_MEALS, icon: PreparingSnacksAndMeals, textLabel: 'Preparing meals/snacks' },
  { value: Responsibilities.SICK_CARE, icon: SickCare, textLabel: 'Sick care' },
  { value: Responsibilities.SLEEP_TRAINING, icon: Bedtime, textLabel: 'Bedtime' },
  { value: Responsibilities.POTTY_TRAINING, icon: ToiletTraining, textLabel: 'Toilet training' },
  { value: Responsibilities.LIGHT_HOUSEWORK, icon: LightHousekeeping, textLabel: 'Light housekeeping' },
  { value: Responsibilities.DO_LAUNDRY, icon: LightLaundry, textLabel: 'Light laundry' },
  { value: Responsibilities.RUN_ERRANDS, icon: RunningErrands, textLabel: 'Running errands' },
];
